export enum ViewStyle {
  GridView = 1,
  ListView = 2,
}

export enum Status {
  Draft = 1,
  InProgress = 2,
  Printing = 3,
  Printed = 4,
  Shipped = 5,
  Received = 6,
  Cancelled = 7,
}

export enum PrinterStatus {
  Offline = 0,
  Online = 1,
  Printing = 2,
  Error = 3,
}

export enum UserStatusEnum {
  Invited = 1,
  Active = 2,
  Disabled = 3,
}

export enum PlanType {
  Essentials = 1,
  Professional = 2,
  Enterprise = 3,
  FreeTrial = 4,
  NoneSelected = 5,
}

export enum Orientation {
  Portrait = 1,
  Landscape = 2,
}

export enum CardSize {
  Cr80 = 1,
  Large = 2,
}

export enum Roles {
  SystemAdmin = 1,
  AccountOwner = 2,
  User = 3,
}

export enum FieldType {
  Text = 1,
  Number = 2,
  Date = 3,
  Image = 4,
  QRCode = 5,
  Code128 = 6,
  Code39 = 7,
  EAN8 = 8,
  EAN16 = 9,
  UPC = 10,
  ImageLink = 11,
}

export enum AccountPermissions {
  None = 0,
  CanCreatePrintJobs = 1,
  CanCreateEditBadgeDesigns = 2,
  CanManageEventData = 4,
  CanCreateEditAddresses = 8,
  CanCreateEditKioskConfigs = 16,
  CanManagePrinters = 32,
  CanCreateEditRegTypes = 64,
  CanCreateViewReports = 128,
  CanManageIntegrations = 256,
  CanCreateEditEvents = 512,
  All = 65535,
}

export enum EventFeatures {
  Dashboard = 1,
  Admin = 2,
  Kiosk = 4,
  Reports = 8,
  Integrations = 16,
}

export enum LocalStorageItems {
  TemplateLibraryViewPreference = 'templateLibraryViewPreference',
  ShowCancelledStatus = 'ShowCancelledStatus',
  SelectedAgentId = 'selectedAgentId',
  EventId = 'eventId',
  EventName = 'eventName',
  EventDate = 'eventDate',
  EventShortName = 'eventShortName',
  CurrentEventSelected = 'currentEventSelected',
  AdminLookUpSelectedColumns = 'adminLookUpSelectedColumns',
  AdminLookUpPinnedColumns = 'adminLookUpPinnedColumns',
  ReportTabSelected = 'ReportTabSelected',
  SelectedReportId = 'selectedReportId',
  DashboardAutoRefreshMinutes = 'dashboardAutoRefreshMinutes',
}

export enum IntegrationType {
  Mtiley = 1,
  Stova = 2,
  Jemex = 3,
  Swoogo = 4,
  Cvent = 5,
  Hubspot = 6,
  Eventbrite = 7,
  RainFocus = 8,
}

export enum IntegrationStatus {
  NotConfigured = 1,
  Inactive = 2,
  Active = 3,
}

export enum AuthRoles {
  Admin = 'admins',
  Onsite = 'onsite',
  Partner = 'partner',
}

export enum SessionStorageItems {
  TemplateRecordSetId = 'templateRecordSetId',
}

export enum TemplateTypeEnum {
  Cr80Landscape = 1,
  Cr80Portrait = 2,
  LargePortrait = 3,
  FourByThree = 4,
  FourByFive = 5,
  FourByTen = 6,
  FourByTwelve = 7,
  LetterPortrait = 8,
  LetterLandscape = 9,
  FourByEleven = 10,
  FourByThreeFive = 11,
  Custom = 12,
}

export enum TransactionType {
  PrintJob = 1,
  Plan = 2,
  Purchase = 3,
  ManualRefund = 4,
  ManualCredit = 5,
  Shipping = 6,
}

export enum Country {
  Canada = 1,
  UnitedStates = 2,
}

export enum ShippingType {
  GoShippo = 1,
  LetterMailUsa = 2,
  LetterMailCanada = 3,
  UserAccountFedEx = 4,
  UserAccountUps = 5,
  UserAccountUsps = 6,
  UserAccountDhl = 7,
  UserAccountApc = 8,
  UserAccountCanadaPost = 9,
  UserAccountPurolator = 10,
}

export enum StarterTemplateBreakpoints {
  xl = 1589,
  lg = 1294,
  md = 1023,
  sm = 767,
}

export enum EventType {
  TradeShow = 1,
  Conference = 2,
  Summit = 3,
  Workshop = 4,
  Seminar = 5,
  Bootcamp = 6,
  Symposium = 7,
  Hackathon = 8,
  AwardsGala = 9,
  Auction = 10,
  Fundraiser = 11,
}

export enum ManageListPresentationType {
  ListView = 1,
  EventView = 2,
}

export enum EventStatus {
  Planned = 0,
  Completed = 1,
  Invoiced = 2,
  Paid = 3,
}

export const LIST_IMPORT_MIME_TYPES: string[] = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export const TEMPLATE_GUIDELINE_DIMENSIONS = {
  CR80Landscape: {
    dimensions: { w: 1014, h: 639 },
    physicalDimensions: '3.375" x 2.125"',
    guideline: { x: 0, y: 0, w: 1014, h: 639, optional: false, default: true, show: true },
    notches: {
      'notch-1': { x: 422, y: 42, w: 170, h: 32, optional: true, default: true, show: true },
      'notch-2': { x: 422, y: 538, w: 170, h: 32, optional: true, default: true, show: false },
    },
    fanfold: {},
  },
  CR80Portrait: {
    dimensions: { w: 639, h: 1014 },
    physicalDimensions: '2.125" x 3.375"',
    guideline: { x: 0, y: 0, w: 639, h: 1014, optional: false, default: true, show: true },
    notches: {
      'notch-1': { x: 245.7, y: 46.5, w: 156.5, h: 31, optional: true, default: true, show: true },
      'notch-2': { x: 244, y: 910, w: 160, h: 31, optional: true, default: true, show: false },
    },
    fanfold: {},
  },
  XXLPortrait: {
    dimensions: { w: 1038, h: 1653 },
    physicalDimensions: '3.5" x 5.5"',
    guideline: { x: 0, y: 0, w: 1038, h: 1653, optional: false, default: true, show: true },
    notches: {
      'notch-1': { x: 127, y: 66, w: 162, h: 31, optional: false, default: true, show: true },
      'notch-2': { x: 740, y: 63, w: 162, h: 31, optional: false, default: true, show: true },
    },
    fanfold: {},
  },
  T4x3: {
    dimensions: { w: 1200, h: 900 },
    physicalDimensions: '4" x 3"',
    guideline: { x: 0, y: 0, w: 1200, h: 900, optional: false, default: true, show: true },
    notches: {},
    fanfold: {},
  },
  T4x35: {
    dimensions: { w: 1200, h: 1050 },
    physicalDimensions: '4" x 3.5"',
    guideline: { x: 0, y: 0, w: 1200, h: 1050, optional: false, default: true, show: true },
    notches: {},
    fanfold: {},
  },
  T4x5: {
    dimensions: { w: 1200, h: 1500 },
    physicalDimensions: '4" x 5"',
    guideline: { x: 0, y: 0, w: 1200, h: 1500, optional: false, default: true, show: true },
    notches: {},
    fanfold: {},
  },
  T4x10: {
    dimensions: { w: 1200, h: 3000 },
    physicalDimensions: '4" x 10"',
    guideline: { x: 0, y: 0, w: 1200, h: 3000, optional: false, default: true, show: true },
    notches: {},
    fanfold: { x: 0, y: 1500, w: 1200, h: 5, optional: false, default: true, show: true },
  },
  T4x11: {
    dimensions: { w: 1200, h: 3300 },
    physicalDimensions: '4" x 11"',
    guideline: { x: 0, y: 0, w: 1200, h: 3300, optional: false, default: true, show: true },
    notches: {},
    fanfold: { x: 0, y: 1650, w: 1200, h: 5, optional: false, default: true, show: true },
  },
  T4x12: {
    dimensions: { w: 1200, h: 3600 },
    physicalDimensions: '4" x 12"',
    guideline: { x: 0, y: 0, w: 1200, h: 3600, optional: false, default: true, show: true },
    notches: {},
    fanfold: { x: 0, y: 1800, w: 1200, h: 5, optional: false, default: true, show: true },
  },
  T85x11: {
    dimensions: { w: 2550, h: 3300 },
    physicalDimensions: '8.5" x 11"',
    guideline: { x: 0, y: 0, w: 2550, h: 3300, optional: false, default: true, show: true },
    notches: {},
    fanfold: {},
  },
  T11x85: {
    dimensions: { w: 3300, h: 2550 },
    physicalDimensions: '11" x 8.5"',
    guideline: { x: 0, y: 0, w: 3300, h: 2550, optional: false, default: true, show: true },
    notches: {},
    fanfold: {},
  },
  T180: {
    dimensions: { w: 1140, h: 3165 },
    physicalDimensions: '10.55" x 3.8"',
    guideline: { x: 0, y: 0, w: 1140, h: 3165, optional: false, default: true, show: true },
    notches: {
      'notch-1': { x: 70.87, y: 59.06, w: 177.17, h: 35.43, optional: false, default: true, show: true },
      'notch-2': { x: 478.35, y: 59.06, w: 177.17, h: 35.43, optional: false, default: true, show: true },
      'notch-3': { x: 885.83, y: 59.06, w: 177.17, h: 35.43, optional: false, default: true, show: true },
    },
    fanfold: { x: 0, y: 1582.5, w: 1140, h: 5, optional: false, default: true, show: true },
  },
  Custom: {
    dimensions: { w: 1, h: 1 },
    physicalDimensions: '1" x 1"',
    guideline: { x: 0, y: 0, w: 1, h: 1, optional: true, default: false, show: false },
    notches: {},
    fanfold: {},
  },
}

export const APP_BASE_URL = process.env.REACT_APP_BASE_URL

export function getLeadsPortalUrl(serviceKey: string): string {
  let baseUrl: string
  switch (process.env.REACT_APP_BASE_URL) {
    case 'https://app.credsnow.com':
    case 'https://app-eu.credsnow.com':
      baseUrl = 'https://leads.credsnow.com'
      break
    case 'https://test.credsnow.com':
      baseUrl = 'https://leads-test.credsnow.com'
      break
    case 'http://localhost:3000':
      baseUrl = 'http://localhost:3002'
      break
    default:
      baseUrl = 'https://leads-dev.credsnow.com'
  }
  return `${baseUrl}/event-admin?s=${encodeURIComponent(serviceKey)}`
}
export const QR_PLACEHOLDER = 'https://app.credsnow.com'
export const BASE_DOMAIN = 'https://credsnow.com'
export const IMAGE_PLACEHOLDER =
  'https://sacredsb2cstorage.blob.core.windows.net/logintemplatecontainer/app_credsnow_com/icon_dynamic_image.svg'
export const EMPTY_PLACEHOLDER =
  'https://sacredsb2cstorage.blob.core.windows.net/logintemplatecontainer/app_credsnow_com/1x1.png'
export const TEMPLATE_THUMBNAIL_HEIGHT_INLINE_GRID_MAX = 225
export const TEMPLATE_THUMBNAIL_FOLDER = '/thumbnails'
export const STARTER_TEMPLATE_THUMBNAILS_BLOB_FOLDER = 'starter-templates'
export const EVENT_IMAGE_FOLDER = 'event-images'
export const STARTER_TEMPLATES_SINGLE_ROW_HEIGHT = 350
export const MINI_THUMBNAIL_TEMPLATE_PREVIEW_SIZE = 50
export const MINI_THUMBNAIL_TEMPLATE_QUICKPRINT_PREVIEW_SIZE = 75
export const FREE_TRIAL_DAYS = 14
export const MAX_RECORDS_PER_IMPORT = 1001
export const TEMPLATE_NAME_MAX_LENGTH = 43
export const MAX_DESIGN_DESCRIPTION_CHARACTERS = 2500
export const MAX_DESIGN_UPLOAD_FILE_SIZE_MB = 50
export const MAX_DESIGN_UPLOAD_TOTAL_SIZE_MB = 100
export const MAX_DESIGN_UPLOAD_FILECOUNT = 25
export const RENDERING_DPI = 300
export const RENDERING_PIXEL_RATIO = 4
export const COLLATERAL_DOMAIN = 'https://sacredsb2cstorage.blob.core.windows.net'
export const COLLATERAL_REPO = 'collateral'
export const COLLATERAL_PREFIX = 'credsnow'
export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const SHIPPING_ESTIMATE_REFRESH = 60000
export const SHIPPING_CUTOFF_TIME_EST = 16
export const SHIPPING_CUTOFF_LOCALE = 'en-US'
export const SHIPPING_TZ_LOCALE = 'America/New_York'
export const SHIPPING_CUTOFF_GMT_OFFSET = 4
export const SHIPPING_DEPOT_ADDRESS = {
  Name: 'CredsNow',
  Street1: '4301 Jenny Lane',
  City: 'Hernando',
  State: 'Mississippi',
  Zip: '38632',
  Country: 'US',
}
export const SYSTEMREPORTFIELDS: { [key: string]: string } = {
  CheckedInDate: 'Checked In Date',
  Prints: 'Number of Prints',
  LastPrintAgentName: 'Last Print Agent',
  Source: 'Last Print Station',
}
export const SG_CONTACT_LIST_ID = 'cf7d389f-4fc9-455a-ac8e-17c72ca9fa79'
export const RECENT_EVENTS_COUNT = 3
export const RECENT_TEMPLATES_COUNT = 3
export const USER_GUIDE_LINK = 'https://sacredsb2cstorage.blob.core.windows.net/credsnow/help/userGuide.md'
export const PREVIEW_ONLY_ELEMENTS = ['guidelines', 'notch-1', 'notch-2', 'fold']
export const DEFAULT_TAG_COLOR = '#000000'
export const CUSTOM_TEMPLATE_WIDTH_MIN_INCHES = 0.3
export const CUSTOM_TEMPLATE_WIDTH_MAX_INCHES = 8.5
export const CUSTOM_TEMPLATE_WIDTH_MIN_MM = 7.94
export const CUSTOM_TEMPLATE_WIDTH_MAX_MM = 215.9
export const CUSTOM_TEMPLATE_HEIGHT_MIN_INCHES = 0.5
export const CUSTOM_TEMPLATE_HEIGHT_MAX_INCHES = 14
export const CUSTOM_TEMPLATE_HEIGHT_MIN_MM = 12.7
export const CUSTOM_TEMPLATE_HEIGHT_MAX_MM = 355.6
export const BADGE_PREVIEW_THUMBNAIL_PIXELRATIO = 0.25
export const PRINT_AGENT_EXPIRY_DAYS = 7
export const PRINT_AGENT_OFFLINE_TIMEOUT_SECONDS = 18
export const KIOSK_OFFLINE_TIMEOUT_SECONDS = 20
export const KIOSK_MONITOR_RETENTION_HOURS = 24
export const KIOSK_LOOKUP_DISPLAY_MIN_SECONDS = 1
export const ONSITE_ROLE_REQUIRED_MESSAGE = 'Please enable CredsNow Onsite for your account to gain access to printing.'
export const TABLE_STICKY_BREAKPOINT = 1025
export const RECORD_SEARCH_MIN_SEARCH_FTS_CHARS = 4
export const RECORD_SEARCH_MIN_SEARCH_COMMON_CHARS = 2
export const RECORD_SEARCH_DEBOUNCE_TIMEOUT = 500
export const RECORD_SEARCH_COMMON_DEBOUNCE_TIMEOUT = 2000
export const AUTO_GENERATED_REGISTRATION_ID_LENGTH = 8
export const AUTO_GENERATED_REGISTRATION_ID_PREFIX = 'A-'
export const PRINT_QUEUE_MANAGER_BREAKPOINT = 1000
export const CAPTELLO_QR_BASE_URL = 'https://ibc.org/home?'
export const STOVA_RS = '\x1E'
export const STOVA_US = '\x1F'
export const MAX_BULK_PRINT_DISTINCT_VALUES = 100
export const REGISTRATION_TYPE_FIELD_ID = -2
export const MAX_RECORDS_FOR_SELECTALL = 250
export const MAX_BATCHES_DROPDOWN_MATCHES = 1500
export const MAX_RECORDS_FOR_SEARCH_ALL_FIELDS = 10000
export const INTEGRATION_PREVIEW_SAMPLE_SIZE = 50
export const EVENT_CHECKINS_MAX_DAYS_RANGE = 21
export const EVENT_CHECKINS_DEFAULT_INTERVAL_SECONDS = 60
export const MINUTES_IN_A_DAY = 1440
export const ADDITIONAL_REGCODE_ATTRIBUTES = ['braindate_flag']
export const ADMIN_LOOKUP_MAX_SORTABLE_RECORDS = 25000

export enum BarcodeCustomizeType {
  None = 0,
  Customize = 1,
  VCard = 2,
  Captello = 3,
  Stova = 4,
}
